<template>
  <v-card tile>

    <v-toolbar card dark color="teal lighten-2">
      <v-toolbar-title>Código: {{ mcodigo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card-text>
      <v-progress-linear v-if="mloading" :indeterminate="true"></v-progress-linear>
      <v-container grid-list-lg fluid class="pa-0" >
        <v-layout row wrap >

          <v-flex xs12 sm8 id="titulo">
            <v-card>
              <v-card-text>
                <h4 class="grey--text text--darken-2">Datos del Centro de Capacitación</h4>
                <v-divider></v-divider>
              <br>
                <h5>Para editar el resto de la información del Centro de Captitación Técnica, debe iniciarl el trámite correspondiente de acuerdo a la reglamentación vigente.</h5>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-flex>

          <v-flex xs12 sm8 id="contenido">
            <v-card>
              <v-text-field type="text" label="Nombre del CCTP" v-model="mcentro.institucioneducativa" disabled>
              </v-text-field>
              <v-text-field type="text" label="Sigla" v-model="minfor.sigla" required></v-text-field>
              <v-text-field type="text" label="Dirección" v-model="mcentro.jurisdiccion_geografica.direccion" disabled>
              </v-text-field>
              <v-text-field type="text" label="Zona" v-model="mcentro.jurisdiccion_geografica.zona" disabled>
              </v-text-field>
              <v-text-field type="text" label="Teléfono" v-model="minfor.telefono" required>
              </v-text-field>
              <v-text-field type="text" label="Correo electrònico" v-model="minfor.correo" required>
              </v-text-field>
            </v-card>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" @click.native="updateInfor">
                Actualizar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>
    <v-snackbar v-model="snack.state" top right :timeout="2500" :color="snack.color"
      :multi-line="snack.mode === 'multi-line'">
      {{ snack.text }}
    </v-snackbar>
  </v-card>
</template>
<script>
import Service from "../services/general";
import axios from "axios";

export default {
  name: "datos-sede-subsede",
  props: ['mcentro', 'mcodigo', 'mloading', 'minfor'],
  data: function () {
    return {
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    }
  },
  methods: {
    updateInfor() {
      axios
        .put(Service.getBase() + 'sedesubsede/' + this.mcodigo, this.minfor, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro actualizado');
          this.mdialog = false;
        })
        .catch(() => {
          this.toast('error', 'No se pudo actualizar');
          console.error('Error al actualizar');
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>

<style>
#titulo{margin: 0px auto;}
#contenido{margin: 0px auto;}
</style>